import { useState, useEffect } from 'react';

// Component to load and manage traffic data from strade and varchi
const useTrafficData = () => {
  const [stradeData, setStradeData] = useState(null);
  const [varchiData, setVarchiData] = useState(null);
  const [stradeTimeseries, setStradeTimeseries] = useState(null);
  const [varchiTimeseries, setVarchiTimeseries] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        // Load all data files in parallel
        const [stradeGeo, stradeTimes, varchiGeo, varchiTimes] = await Promise.all([
          fetch('/data/strade/streets_geo.json').then(res => res.json()),
          fetch('/data/strade/timeseries_long.json').then(res => res.json()),
          fetch('/data/varchi/varchi_geo.json').then(res => res.json()),
          fetch('/data/varchi/varchi_timeseries_long.json').then(res => res.json())
        ]);

        // Process strade data - create lookup by street_direction
        const stradeByDirection = {};
        stradeGeo.forEach(item => {
          stradeByDirection[item.street_direction] = item;
        });

        // Process varchi data - create lookup by marker_key
        const varchiByKey = {};
        varchiGeo.forEach(item => {
          varchiByKey[item.marker_key] = item;
        });

        // Process timeseries data - group by street/marker
        const stradeTimesByDirection = {};
        stradeTimes.forEach(item => {
          if (!stradeTimesByDirection[item.street_direction]) {
            stradeTimesByDirection[item.street_direction] = [];
          }
          stradeTimesByDirection[item.street_direction].push(item);
        });

        const varchiTimesByKey = {};
        varchiTimes.forEach(item => {
          if (!varchiTimesByKey[item.marker_key]) {
            varchiTimesByKey[item.marker_key] = [];
          }
          varchiTimesByKey[item.marker_key].push(item);
        });

        setStradeData({
          geo: stradeGeo,
          byDirection: stradeByDirection,
          timeseriesByDirection: stradeTimesByDirection
        });

        setVarchiData({
          geo: varchiGeo,
          byKey: varchiByKey,
          timeseriesByKey: varchiTimesByKey
        });

        setStradeTimeseries(stradeTimes);
        setVarchiTimeseries(varchiTimes);

        setLoading(false);
      } catch (err) {
        console.error('Error loading traffic data:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return {
    stradeData,
    varchiData,
    stradeTimeseries,
    varchiTimeseries,
    loading,
    error
  };
};

export default useTrafficData;